import { Button, Card, Checkbox, Col, Form, Radio, Row, Typography } from 'antd';
import Title from 'antd/lib/typography/Title';
import { Formik } from 'formik';
import * as React from 'react';
import { UserQueries } from '../../queries/user-queries';
import { ExportFileFormat } from '../../constants/exportFileFormat';
import "./UserExport.scss";
import { b64toBlob } from '../../utilites/fileHelper';
import { UserExportOptions } from '../../models/user-export-options-interface';

function UserExportPage() {
  const { Text } = Typography;

  const usersExportMutation = UserQueries.useUsersExport();

  /**
   * Export users
   * @param values 
   */
  const handleSubmit = async (values: UserExportOptions) => {
    const response = await usersExportMutation.mutateAsync(values);
    const url = window.URL.createObjectURL(new Blob([b64toBlob(response.data)]));
    const link = document.createElement('a');
    link.href = url;
    const contentDisposition = response.headers['content-disposition'];
    let fileName = contentDisposition.split('filename=')[1];
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
}

  const gridStyle: React.CSSProperties = {
    width: '100%'
  };

  return <>
    <Card title="User Export">
      <Formik
        enableReinitialize
        initialValues={{
          excludeDemoCompanies: true,
          excludeTrialCompanies: false,
          exportFormat: 0,
          partnerId: 1
        }}
        onSubmit={(val) => handleSubmit(val)}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue
        }) => (
          <Form
            id="grantAccessForm"
            onFinish={handleSubmit}
            layout="vertical"
          >
            <Row gutter={[32, 32]}>
              <Col span={12}>
                <Form.Item label="Exclude Companies">
                  <Card>
                    <Card.Grid style={gridStyle} hoverable={false}>
                      <Checkbox name="excludeDemoCompanies" checked={values.excludeDemoCompanies} onChange={handleChange} disabled={usersExportMutation.isLoading}>
                        Exclude Demo Companies
                      </Checkbox>
                      <Row className="description">
                        <Text type="secondary">Excludes any companies marked with the demo flag</Text>
                      </Row>
                    </Card.Grid>
                    <Card.Grid style={gridStyle} hoverable={false}>
                      <Checkbox name="excludeTrialCompanies" checked={values.excludeTrialCompanies} onChange={handleChange} disabled={usersExportMutation.isLoading}>
                        Exclude Trial Companies
                      </Checkbox>
                      <Row className="description">
                        <Text type="secondary">Excludes any companies currently using a trial base product</Text>
                      </Row>
                    </Card.Grid>
                  </Card>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Select Format">
                  <Radio.Group onChange={(e) => setFieldValue('exportFormat', e.target.value)} value={values.exportFormat}>
                    <Card>
                      <Card.Grid style={gridStyle} hoverable={false}>
                        <Radio value={ExportFileFormat.Xlsx} disabled={usersExportMutation.isLoading}>
                          XLSX
                        </Radio>
                        <Row className="description">
                          <Text type="secondary">Modern Excel format for cross compatibility with other spreadsheet applications</Text>
                        </Row>
                      </Card.Grid>
                      <Card.Grid style={gridStyle} hoverable={false}>
                        <Radio value={ExportFileFormat.Xls} disabled={usersExportMutation.isLoading}>
                          XLS
                        </Radio>
                        <Row className="description">
                          <Text type="secondary">Legacy Excel format (pre-2007)</Text>
                        </Row>
                      </Card.Grid>
                      <Card.Grid style={gridStyle} hoverable={false}>
                        <Radio value={ExportFileFormat.Csv} disabled={usersExportMutation.isLoading}>
                          CSV
                        </Radio>
                        <Row className="description">
                          <Text type="secondary">CSV format exported by ZIP file</Text>
                        </Row>
                      </Card.Grid>
                    </Card>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>
            <Row justify="end">
              <Button type="primary" htmlType="submit" loading={usersExportMutation.isLoading}>Export</Button>
            </Row>
          </Form>
        )}
      </Formik>
    </Card>
  </>
}

export default UserExportPage;